import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { selectContentTotalLength } from '../../spacesPlatform/selectors/ContentSelectors';
import { AllSchedulesSpace, AllSchedulesSpaceDispatchProps, AllSchedulesSpaceOwnProps, AllSchedulesSpaceStateProps } from './AllSchedulesSpace';

const mapStateToProps: MapStateToProps<AllSchedulesSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedSchedules: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllSchedulesSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedAllSchedulesSpace: React.ComponentClass<AllSchedulesSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSchedulesSpace);
